import ErrorMessageType from './ErrorMessageType';
import QueryErrorStateMessage from './QueryErrorStateMessage';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
import { AnyCrmObjectTypePropType } from 'customer-data-objects-ui-components/propTypes/CrmObjectTypes';
import { useTimelineActionHandlerContext, TRIGGER_RHUMB_FAILURE } from 'crm-events-data';
import { useEffect } from 'react';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
function ProfileTimelineErrorMessage({
  errorMessageType,
  objectType
}) {
  const handleTimelineAction = useTimelineActionHandlerContext();
  useEffect(() => {
    handleTimelineAction(TRIGGER_RHUMB_FAILURE);
  }, [handleTimelineAction]);
  return /*#__PURE__*/_jsx(View, {
    paddingBlock: "200",
    as: "div",
    children: /*#__PURE__*/_jsx(QueryErrorStateMessage, {
      errorMessageType: errorMessageType,
      objectType: objectType
    })
  });
}
ProfileTimelineErrorMessage.propTypes = {
  errorMessageType: ErrorMessageType,
  objectType: AnyCrmObjectTypePropType
};
ProfileTimelineErrorMessage.displayName = 'ProfileTimelineErrorMessage';
export default ProfileTimelineErrorMessage;